import React, { Component } from "react";
import ContractForm from "./ContractForm";
import SmallModal from "../../../hoc/UI/SmallModal/SmallModal";
import { Button } from "rsuite";

class Contract extends Component {
  state = {
    proj_contract_id: null
  };

  componentDidMount() {
    this.props.contract.fetch();
  }
  render() {
    let smallModal = null;
    if (this.props.showSmallModal) {
      smallModal = (
        <SmallModal>
          <ContractForm
            toggleSmallModalHandler={this.props.toggleSmallModalHandler}
            currentContract={
              this.state.proj_contract_id === null
                ? null
                : this.props.contract.contract.find(
                    contract =>
                      contract.proj_contract_id === this.state.proj_contract_id
                  )
            }
            update={this.props.contract.update}
            add={this.props.contract.add}
            projectID={this.props.currentProjectID}
            disabled={this.props.disabled}
          />
        </SmallModal>
      );
    }

    return (
      <div>
        {this.props.disabled ? null : (
          <div style={{ textAlign: "right" }}>
            <Button
              className={"my-2"}
              color={"blue"}
              onClick={() => {
                this.setState({ proj_contract_id: null });
                this.props.toggleSmallModalHandler();
              }}
            >
              Create New Contract
            </Button>
          </div>
        )}
        {smallModal}

        <table className="table">
          <thead>
            <tr>
              <th>Contract Name</th>
              <th>Is Master Contract</th>
              <th>Display Order</th>
              <th>Cost Note</th>
              {this.props.disabled ? null : <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {this.props.contract.contract.map(item => (
              <tr
                key={item.proj_contract_id}
                // onClick={e => {
                //   if (e.target.type !== "button") {
                //     this.setState({
                //       proj_contract_id: item.proj_contract_id
                //     });
                //     this.props.toggleSmallModalHandler();
                //   }
                // }}
              >
                <td>{item.contract_name}</td>
                <td>{item.is_master_contract ? "Yes" : "No"}</td>
                <td>{item.display_order}</td>
                <td>{item.cost_note}</td>
                {this.props.disabled ? null : (
                  <td>
                    <Button
                      color={"blue"}
                      type="button"
                      onClick={() => {
                        this.setState({
                          proj_contract_id: item.proj_contract_id
                        });
                        this.props.toggleSmallModalHandler();
                      }}
                    >
                      Edit
                    </Button>{" "}
                    <Button
                      color={"red"}
                      type="button"
                      onClick={() =>
                        this.props.contract.delete(
                          item.proj_contract_id,
                          this.props.currentProjectID
                        )
                      }
                    >
                      Delete
                    </Button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default Contract;
